export const BASE_URL = process.env.REACT_APP_API_URL || "https://medayus.sanvima.net/medayus-api";
export const ASSET_URL = process.env.REACT_APP_API_URL || "https://medayus.sanvima.net/medayus-api";